import {searchBox, filters, search} from './drupalSettings';
import fetchHotelsList from 'js/apiCalls/hotelsList';
import {mergeSearchParams} from '@helpers/urlHelpers';
import {SEARCH_FILTERS} from 'js/url';

// Helper for success
const success = (redirect = false) => ({ success: true, redirect });

// Helper for failure (The "Standardized Report")
const fail = (field, message) => ({
  success: false,
  field,   // 'destination', 'dates', 'apartments'
  message
});

/**
 * STRATEGY: DEFAULT / GENERIC
 */
const submitDefault = async (urlApi, dispatch, toggleLoader) => {
  const redirectUrl = searchBox?.searchResultsUrl;
  const {applyChanges, getState, resetParamImmediate} = urlApi;
  applyChanges();

  const {parameters} = getState();
  if (!parameters.q) {
    return fail('destination');
  }
  toggleLoader(true);
  resetParamImmediate(SEARCH_FILTERS);
  window.location.href = `${redirectUrl}${window.location.search}`;
  return success(true);
};

/**
 * STRATEGY: HOMEPAGE
 */
const submitHomepage = async (urlApi, dispatch, toggleLoader) => {
  const {applyChanges, getState, resetParam} = urlApi;
  const {uiParams} = getState();

  if (!uiParams.dateIn || !uiParams.nbNight) {
    return submitDefault(urlApi, dispatch, toggleLoader);
  }

  toggleLoader(true);
  resetParam(SEARCH_FILTERS);
  applyChanges();
  const {queryString} = getState();

  const {data} = await fetchHotelsList(queryString);

  if (!data?.redirect) {
    return submitDefault(urlApi, dispatch, toggleLoader);
  }

  window.location = data?.redirect;
  return success(true);
};

/**
 * STRATEGY: HOTEL PAGE
 */
const submitHotelPage = async (urlApi, dispatch, toggleLoader) => {
  const bookingUrlBase = filters?.linkToFirstStep;
  const bookingUrlDefault = filters?.submit?.url;
  const {applyChanges, getState} = urlApi;
  applyChanges();

  const {parameters, queryString} = getState();

  if (!bookingUrlBase && !bookingUrlDefault) {
    return submitDefault(urlApi, dispatch, toggleLoader);
  }

  if (!parameters.hotelId) {
    return submitHomepage(urlApi, dispatch, toggleLoader);
  }

  if (!parameters.dateIn || !parameters.nbNight) {
    return fail('dates');
  }
  toggleLoader(true);
  const bookingUrlData = mergeSearchParams(new URL(bookingUrlBase || bookingUrlDefault), queryString);
  window.location.href = bookingUrlData.toString();
  return success(true);
};

/**
 * STRATEGY: UPDATE OR REDIRECT (Smart Search Results)
 * Used for Search Results Page.
 * * Logic:
 * 1. Checks if 'destination' has changed compared to the current active URL parameters.
 * 2. If CHANGED: Redirects to a new search page (Standard Submit).
 * 3. If SAME: Updates the current URL in place (pushState) and syncs Redux (SPA behavior).
 */
const submitUpdateOrRedirect = async (urlApi, dispatch, toggleLoader) => {
  const {getState, applyChanges} = urlApi;
  const {parameters, uiParams} = getState();

  if (parameters.q !== uiParams.q) {
    return submitHomepage(urlApi, dispatch, toggleLoader);
  }

  if (parameters.radius !== uiParams.radius) {
    applyChanges();
    window.location.reload();
    return success(true);
  }

  applyChanges();
  return success();
};

/**
 * STRATEGY MAP
 */
export default {
  'homepage': submitHomepage,
  'hotelPage': submitHotelPage,
  'updateOrRedirect': submitUpdateOrRedirect,
  'default': submitDefault,
};
